import { render } from "./TopAdSense.vue?vue&type=template&id=65803b9c&scoped=true"
import script from "./TopAdSense.vue?vue&type=script&lang=js"
export * from "./TopAdSense.vue?vue&type=script&lang=js"

import "./TopAdSense.vue?vue&type=style&index=0&id=65803b9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65803b9c"]])

export default __exports__